import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Appstore, AppDispatch } from "../redux/store";
import {
  fetchUserPreferences,
  patchUserPreferencesThunk,
} from "../redux/states/userPreferences.state";
import { UserPreferencesPatch } from "../interfaces/models/IUserPreferences";

export function useUserPreferences() {
  const dispatch = useDispatch<AppDispatch>();
  const { userPreferences, loading, error } = useSelector(
    (state: Appstore) => state.userPreferences
  );

  const patchUserPreferences = useCallback(
    async (partial: UserPreferencesPatch) => {
      const result = await dispatch(patchUserPreferencesThunk(partial));
      if (patchUserPreferencesThunk.fulfilled.match(result)) {
        return result.payload;
      }
      throw (result as any).error;
    },
    [dispatch]
  );

  const refresh = useCallback(
    () => dispatch(fetchUserPreferences()),
    [dispatch]
  );

  return {
    userPreferences,
    loading,
    error,
    patchUserPreferences,
    refresh,
  };
}
